import { AddFavoriteData, API_Data_Add_Favorite_Response, API_Data_Delete_Favorite_Response } from "@/interfaces/api/favorites/favorites_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

/**
 * Add a profile’s favorite game on the server
 * 
 * @param param0 - An object that contains the profileId and a payload with the data to be sent to the server
 * @returns - Returns the data of the favorite game
 */
export async function addFavorite ({ profileId, payload }: { profileId: string, payload: AddFavoriteData }): Promise<API_Data_Add_Favorite_Response> {
  const res = await fetcher(`/api/self/profiles/${profileId}/favorites`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  const response = await res.json() as API_Response<API_Data_Add_Favorite_Response>

  if (!res.ok) throw { code: res.status, description: 'Unknow add profile error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Add favorite data missing in response' } as API_Error

  return response.data
}

/**
 * Delete a favorite on the server
 * 
 * @param profileId Profile identifier
 * @returns 
 */
export async function deleteFavorite (profileId: string, gameId: string): Promise<API_Data_Delete_Favorite_Response> {
  const res = await fetcher(`/api/self/profiles/${profileId}/favorites/${gameId}`, { 
    method: 'DELETE',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  const response = await res.json() as API_Response<API_Data_Delete_Favorite_Response>

  if (!res.ok) throw { code: res.status, description: 'Unknow delete favorite error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Delete favorite data missing in response' } as API_Error

  return response.data
}